import * as React from "react";
import styles from "./Textarea.module.css";
import { cn } from "../../../utils/cn";

const Textarea = ({
  className,
  ...props
}: React.TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  return <textarea className={cn(styles.textarea, className)} {...props} />;
};

export { Textarea };
